import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { CONTACT } from 'config/contact';

const CTASection = () => {
  return (
    <div className="bg-gradient-to-br from-primary to-secondary rounded-xl p-8 md:p-12 text-center">
      <div className="max-w-3xl mx-auto">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-6">
          <Icon name="Rocket" size={32} color="white" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Ready to Transform Your Business?
        </h2>

        <p className="text-xl text-white/90 mb-8">
          Join hundreds of businesses saving 40-70 hours monthly with intelligent automation.
          Let's discuss how we can optimize your processes.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/contact">
            <Button
              variant="default"
              size="lg"
              iconName="Calendar"
              iconPosition="left"
              className="bg-white text-primary hover:bg-white/90"
            >
              Book Free Automation Audit
            </Button>
          </Link>

          <a
            href={CONTACT.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block"
          >
            <Button
              variant="outline"
              size="lg"
              iconName="MessageCircle"
              iconPosition="left"
              className="border-white text-white hover:bg-white/10"
            >
              Chat on WhatsApp
            </Button>
          </a>
        </div>

        <div className="mt-8 flex items-center justify-center space-x-8 text-white/80">
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle" size={20} />
            <span className="text-sm">Free Consultation</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle" size={20} />
            <span className="text-sm">No Credit Card Required</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle" size={20} />
            <span className="text-sm">Quick Setup</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTASection;